import VideoSection from 'elem/compPage/delta-3-max-series/pages/product/components/Common/VideoSection';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const CoverSection3: React.FC = () => {
    const { t } = useLang('CoverSection3');

    return (
        <div className={`page-coverSection3 range4 ${styles.CoverSection3} GtmModuleData-section`} data-section-id="d3c-CoverSection3">
            <VideoSection
                sectionId="videoSection3"
                triggerSelector="#videoSection3"
                videoSrc="https://websiteoss.ecoflow.com/upload/video/1759042033063/03.mp4"
                posterSrc="https://websiteoss.ecoflow.com/figma-uploads/1758771697195-hbr0y3-compressed-20250925-100921.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
};

export default CoverSection3;
